import React, { useEffect, useState } from "react";
import { Div } from "../../../styles/Common";
import PropTypes from "prop-types";
import { theme } from "../../../styles/theme";
import styled, { keyframes } from "styled-components";
import useGetUserProfile from "../../ProfileInfo/hooks/useGetUserProfile";
import { getUserInfo } from "../../../utilities/helpers";
import dayjs from "dayjs";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid ${theme.colors.white};
  border-top: 4px solid ${theme.colors.red}; // Color destacado
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`;

export const SurveyExternal = ({ isMobile, url }) => {
    const [isLoading, setIsLoading] = useState(true);
    const { nameid, unique_name } = getUserInfo();
    const getUserProfile = useGetUserProfile(nameid);
    const { data: dataUserProfile, isSuccess: isSuccessUserProfile } =
        getUserProfile;

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    useEffect(() => {
        if (isSuccessUserProfile && dataUserProfile?.data?.result) {
            let dataUser = {
                name: dataUserProfile?.data?.result[0]?.name,
                lastName: dataUserProfile?.data?.result[0]?.lastName,
                ind: dataUserProfile?.data?.result[0]?.phoneNumberCode,
                phone: dataUserProfile?.data?.result[0]?.phoneNumber,
                email: dataUserProfile?.data?.result[0]?.email,
                department: dataUserProfile?.data?.result[0]?.departmentId,
                municipality: dataUserProfile?.data?.result[0]?.cityId,
                maps: dataUserProfile?.data?.result[0]?.exactAddress,
                address: dataUserProfile?.data?.result[0]?.address,
                instruction: dataUserProfile?.data?.result[0]?.instruction,
                zone: dataUserProfile?.data?.result[0]?.zone,
                maritalStatus: dataUserProfile?.data?.result[0]?.maritalStatusId,
                gender: dataUserProfile?.data?.result[0]?.genderId,
                birthdate: !!dataUserProfile?.data?.result[0].birthDate
                    ? dayjs(dataUserProfile?.data?.result[0]?.birthDate)
                    : null,
                role: dataUserProfile?.data?.result[0]?.roleHouseId,
                incomeRange: dataUserProfile?.data?.result[0]?.incomeRangeId,
                numberChildren: dataUserProfile?.data?.result[0]?.numberChildrenId,
                physicalActivities:
                    dataUserProfile?.data?.result[0]?.frequencyActivitiesPhysicalId,
                profession: dataUserProfile?.data?.result[0]?.professionsId,
                instagram: dataUserProfile?.data?.result[0]?.instagram,
                isPregnant: dataUserProfile?.data?.result[0]?.isPregnant,
                isInterestedTechnology:
                    dataUserProfile?.data?.result[0]?.isInterestedTechnology,
                householdRole: dataUserProfile?.data?.result[0]?.isBuyManagerHome,
                pets: dataUserProfile?.data?.result[0]?.petsId,
                hobbies: dataUserProfile?.data?.result[0]?.hobbiesId,
                }
        } else {

        }
    }, [dataUserProfile, isSuccessUserProfile]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Div width="100%" height="100vh" direction="column" >
            {isLoading && (
                <Div
                width="100%"
                height="100%"
                align="center"
                justify="center"
                background={theme.colors.blackBlur1}
                >
                <Spinner />
                </Div>
            )}
            <iframe
                src={url}
                title="Embedded URL"
                width="100%"
                height="100%"
                style={{ border: "none", flex: 1, display: isLoading ? "none" : "block", marginBottom: isMobile? "150px": "150px" }}
                onLoad={handleIframeLoad}
            />
        </Div>
    );
};

SurveyExternal.propTypes = {
    isMobile: PropTypes.bool,
    url: PropTypes.string.isRequired,
};